__turbopack_context__.v({
  "button": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__button",
  "card": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__card",
  "component": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__component",
  "content": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__content",
  "header": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__header",
  "icon": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__icon",
  "inputGrid": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__inputGrid",
  "inputGroup": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__inputGroup",
  "insightItem": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__insightItem",
  "insightText": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__insightText",
  "insightsCard": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__insightsCard",
  "insightsContent": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__insightsContent",
  "insightsHeader": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__insightsHeader",
  "insightsIcon": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__insightsIcon",
  "insightsTitle": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__insightsTitle",
  "resultAmount": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__resultAmount",
  "resultCard": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__resultCard",
  "resultGrid": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__resultGrid",
  "resultHeader": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__resultHeader",
  "resultItem": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__resultItem",
  "resultItemLabel": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__resultItemLabel",
  "resultItemValue": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__resultItemValue",
  "resultLabel": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__resultLabel",
  "resultSubtext": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__resultSubtext",
  "subtitle": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__subtitle",
  "title": "BorrowingCapacityCalculator-module-scss-module__JNX7UG__title",
});
